const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiljBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "miljo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.65 67.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "ac314e3a-17e1-4755-99df-d81eb03e6113",
    "data-name": "border",
    d: "M2,63.75A11.3,11.3,0,0,1,.28,60.23c-.36-1.16,2.53-3.13,2.53-3.13l0-39.86A10.27,10.27,0,0,1,.37,12.35C0,9.62,1,7.35,2.81,6.57s5.3-4,8-5.2,9.12.68,9.73,1S24.4.83,28.34.29s9,4.89,10.27,6.28-.51,6.2-3.36,6.63-2,.8-2.74,3.07-7.38,3.91-7.38,3.91V33.77h27.1V58.16H54.4v5.61H52.77v3.4H2.68S2.54,64.24,2,63.75Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiljBorder);
export default __webpack_public_path__ + "static/media/miljö-border.1cebe372e4176c5bc1a9cf9d1d1bc3c6.svg";
export { ForwardRef as ReactComponent };